import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import '../../src/assets/css/style.css';
import CustomLine from "./CustomLine";
import AppoinmentModal from "./AppoinmnetModal";
import { fetchCaseStudies, getSeoByUrl } from "../api/api";
import MainBannerImage1 from '../../src/assets/images/casebanner1.png';
import { Helmet } from "react-helmet-async";

const CaseStudy = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [caseStudies, setCaseStudies] = useState([]);
    const [seoData, setSeoData] = useState({});
    const navigate = useNavigate();

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleGetStartedClick = () => {
        navigate('/register');
    };

    useEffect(() => {
        const getCaseStudies = async () => {
            try {
                const data = await fetchCaseStudies();
                if (data.status && data.data) {
                    setCaseStudies(data.data);
                }
            } catch (error) {
                console.error("Error fetching case studies:", error);
            }
        };
        getCaseStudies();
    }, []);

    useEffect(() => {
        const fetchSeoData = async () => {
            try {
                const response = await getSeoByUrl("case-study");
                if (response.success && response.data) {
                    setSeoData(response.data);
                }
            } catch (error) {
                console.error("Error fetching SEO data:", error);
            }
        };
        fetchSeoData();
    }, []);

    return (
        <div>
            <Helmet>
                <title>
                    {seoData.metaTitle || "Case Study | Nutrillion"}
                </title>

                <meta
                    name="description"
                    content={seoData.metaDescription || "Real stories and real transformations with Nutrillion case studies"}
                />

                <meta
                    name="robots"
                    content={seoData.robotsTxt || "index, follow"}
                />

                <link
                    rel="canonical"
                    href={seoData.canonicalUrl || "https://nutrillion.one/case-study"}
                />
            </Helmet>
            <section
                className="relative w-full main-padding-mobile pt-4 sm:pt-0 sm:px-0 case-h"
                style={{
                    backgroundImage: `url(${MainBannerImage1})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    height: "90vh",
                }}
            >
                <div className="relative w-full overflow-hidden h-full">
                    <div className="custom-padding xl-screen-padding absolute inset-0 flex flex-col justify-center text-left text-white buttons-container-space">
                        <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md font-lato block sm:flex items-center slide-left">
                            <CustomLine />
                            <span className="ml-0 sm:ml-2">Nutrillion Case Studies</span>
                        </p>
                        <h1 className="custom-padding-bottom text-lg sm:text-xl custom-line-height md:text-xl lg:text-4xl font-semibold text-black leading-tight client-text slide-left">
                            Real Stories, Real Transformations
                        </h1>
                        <p className="custom-padding-bottom text-p text-[#7C517E] text-md sm:text-md font-lato sm:block slide-left">
                            Explore how our precision-driven approach has rejuvenated lives, helping individuals <br />overcome chronic health challenges, optimize performance, and regain vitality.
                        </p>
                    </div>
                </div>
                <div className="absolute buttons-container flex flex-row space-x-3">
                    <Link to="/service">
                        <button className="bg-gray-800 common-btn-all-second text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-[120px] sm:w-auto md:w-[150px] lg:w-[120px]">
                            Read More
                        </button>
                    </Link>
                    <button className="bg-[#8f762c] common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-[120px] sm:w-auto md:w-[150px] lg:w-[120px]" onClick={openModal}>
                        Contact Us
                    </button>
                    <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
                </div>
            </section>

            {caseStudies.length > 0 ? (
                <div className="pt-80 pb-80"> 
                    {caseStudies.map((study, index) => (
                        <div key={index} className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center custom-padding xl-screen-padding case-top">
                            <div className="md:col-span-12 bg-[#f2efed] p-8 rounded-lg flex flex-col md:flex-row">
                                <div className="md:w-1/4 relative rounded-lg overflow-hidden">
                                    <img src={study.imageUrl} alt={study.title} className="w-full h-full object-cover rounded-lg" />
                                </div>
                                <div className="md:w-3/4 mt-4 md:mt-0 md:pl-8">
                                    <p className="text-xl md:text-2xl font-bold text-[#8f762c] client-text">{study.sub_title}</p>

                                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 client-text mt-4">{study.title}</h3>
                                    {study.description ? (
                                        <div
                                            className="text-[#939a9e] text-p mt-4 mb-6 font-lato"
                                            dangerouslySetInnerHTML={{ __html: study.description }}
                                        />
                                    ) : (
                                        <p className="text-[#939a9e] text-p mt-4 mb-6">No description available</p>
                                    )}

                                    <div className="flex sm:justify-end justify-start">
                                        <button className="bg-button-services common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-[120px] sm:w-auto md:w-[150px] lg:w-[120px]" onClick={openModal}>
                                            Read more
                                        </button>
                                    </div>
                                    <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-center text-gray-600 mt-10">Loading case studies...</p>
            )}

            <section className="pt-80 pb-80 custom-padding xl-screen-padding">
                <div className="w-full h-[50vh] flex justify-center items-center flex-col" style={{ background: 'linear-gradient(to right, #fff1c6, #cccccc, #dac587, #f2fded)', borderRadius: '70px', overflow: 'hidden' }}>
                    <div className="text-center px-4">
                        <h1 className="text-xl sm:text-2xl md:text-2xl pb-6 font-semibold text-gray-800 client-text">Your Health, Your Potential – Resolved!</h1>
                        <p className="text-p text-[#6e777e]">These success stories showcase the power of science-backed, precision nutrition. Whether you're battling chronic conditions, seeking peak performance, or striving for optimal well-being, Nutrillion tailors solutions to your unique biology.</p>
                    </div>
                    <div className="flex justify-center space-x-4 mt-6">
                        <button 
                            onClick={handleGetStartedClick}
                            className="bg-gray-800 common-btn-all-second text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-auto"
                        >
                            Get Started Now
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CaseStudy;